<script lang="ts">
	import { storyblok } from '$lib/state/storyblok.svelte';
	import Blok from '$lib/storyblok/blok.svelte';
	import EmailModal from '$lib/storyblok/parts/emailModal.svelte';
	import log from '$lib/utils/log';
	import type { ISbStoryData } from '@storyblok/js';
	import { onMount } from 'svelte';

	interface Props {
		content: ISbStoryData<{
			body: Array<ISbStoryData>;
			open_delay: string;
			ignored_url_params?: string;
			template?: string;
			use_template_body?: boolean;
			use_template_settings?: boolean;
		}>['content'];
	}

	let { content }: Props = $props();

	let modal = $state<{ show: () => void; hide: () => void; remove: () => void }>();

	async function mergeTemplate(uuid: string) {
		try {
			const { data } = await storyblok.client.getStories({
				starts_with: 'globals/email-capture-templates/',
				by_uuids: uuid
			});

			if (data.stories.length === 0) return null;

			const template = data.stories[0].content;

			mergedContent = {
				...content,
				...(content.use_template_body && {
					body: template.body
				}),
				...(content.use_template_settings && {
					open_delay: template.open_delay,
					ignored_url_params: template.ignored_url_params
				})
			};
		} catch (err) {
			log.scope('emailCaptureEmbed').exception(err);
		}
	}

	let mounted = $state(false);
	let mergedContent = $state(content);

	onMount(async () => {
		if (content.template) {
			await mergeTemplate(content.template);
		}
		mounted = true;
	});
</script>

{#if !mergedContent.use_template_settings || mounted}
	<EmailModal
		bind:modal
		size="fullscreen"
		eventName="Show Quiz Modal"
		openDelay={parseInt(mergedContent.open_delay, 10)}
		ignoredParams={mergedContent.ignored_url_params?.split(',')}
		modalParam="quiz"
	>
		{#if !mergedContent.use_template_body || mounted}
			{#each mergedContent.body as block}
				<Blok content={block} onclose={() => modal?.hide()} />
			{/each}
		{/if}
	</EmailModal>
{/if}
